/**
   * Códigos de las vistas EPC. Mantener sincronizado con _LayerBelongsToView
   * y con los layer.code del worker (CadProcessor._GetLayers).
   */
export const VIEW_CODE = Object.freeze({
  PILINGS:    'pilings',
  STRUCTURES: 'structures',
  MODULES:    'modules',
  PANELS:     'panels',
})

/** Vista que se aplica por defecto tras procesar y al resetear. */
export const DEFAULT_VIEW = VIEW_CODE.STRUCTURES
